import * as React from 'react';

export function StickyNoteIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={20} height={20} viewBox='0 0 20 21' {...props}>
			<path
				fill='currentcolor'
				d='M12.222 16.207v-2.874c0-.613.5-1.11 1.111-1.11h2.874l-3.985 3.984Zm-10 1.57V2.223h15.556V10h-4.445A3.337 3.337 0 0 0 10 13.333v4.445H2.222ZM17.778 0H2.222A2.225 2.225 0 0 0 0 2.222v15.556C0 19.003.997 20 2.222 20H10c.91 0 2.039-.467 2.682-1.111l6.207-6.207C19.533 12.038 20 10.91 20 10V2.222A2.225 2.225 0 0 0 17.778 0Z'
				fillRule='evenodd'
			/>
			<path fill='none' stroke='currentcolor' strokeWidth='2' strokeMiterlimit='10' d='M4 6h12M4 9h5M4 13h4' />
		</svg>
	);
}
